import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayFields, (displayField) => {
      return (_openBlock(), _createElementBlock("div", {
        key: displayField.label
      }, [
        _createElementVNode("p", {
          style: _normalizeStyle({ color: _ctx.setLabelColor }),
          innerHTML: _ctx.formatText(displayField.label)
        }, null, 12, _hoisted_1),
        _cache[0] || (_cache[0] = _createTextVNode(": ")),
        _createElementVNode("p", {
          style: _normalizeStyle({ color: _ctx.setValueColor }),
          innerHTML: _ctx.formatText(displayField.value)
        }, null, 12, _hoisted_2)
      ]))
    }), 128))
  ]))
}